import { Category } from '../../molecules/Category'
import { Container } from './styles'
import React from 'react'
import { Typography } from '@taglivros/tag-components'
import { useCategory } from '../../../contexts/CategoryContext'


export function CategoriesOptions() {
  const { activeCategoryId, setActiveCategoryId, categories, findCategoryById, setActiveCategory } = useCategory()

  const handleSelectCategory = ( categoryId ) => {
    setActiveCategoryId( categoryId )
    setActiveCategory( findCategoryById( categoryId ) )
  }

  return (
    <Container>
      <Typography
        as="span"
        color="cinza500"
        fontWeight="l"
        variant="heading1"
      >
        Escolha sua caixinha
      </Typography>

      {categories.map( category => {
        return (
          <Category
            categoryId={ category.id }
            handleCategoryClick={ handleSelectCategory }
            isSelected={ category.id === activeCategoryId }
            key={ category.id }
          />
        )
      } ) }

    </Container>
  )
}
